<template>
  <div class="sky-page-terminal-view">
    <div class="page-from-item wsp-display-flex wsp-padding-tb-12">
      <div class="page-from-value from-value">
        <el-button type="primary" @click="onSubmit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
    <div class="page-from-item wsp-display-flex">
      <div class="page-from-label from-label">场景选择：</div>
      <div class="page-from-value from-value">
        <el-radio-group v-model="selectSceneId" size="mini" @change="handleSceneSelectionChange">
          <el-radio-button v-for="(scene, index) in scenes" :key="index" :label="scene.sceneId">{{
            scene.sceneName
          }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="page-from-item">
      <div>
        <span>终端选择:</span>
        <div class="page-function-toolbar">
          <el-button icon="el-icon-refresh" class="toolbar-left" @click="refreshTable"></el-button>
          <el-input
            placeholder="请输入终端型号查询"
            class="toolbar-input"
            size="medium"
            v-model="searchKeyword"
            @blur="searchReq"
            @change="searchReq"
          >
            <span slot="suffix" class="el-input__suffix"
              ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
            </span>
          </el-input>
          <div class="el-icon-warning wsp-padding-lr-6 wsp-line-height-24 bg-red">
            当前筛选对大小写敏感
          </div>
          <el-pagination
            class="toolbar-right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="handelPrev"
            @next-click="handelNext"
            :page-sizes="[5, 10, 20, 50, 100]"
            layout="total,sizes,prev,sp,next"
            :current-page="page"
            :page-size="pageSize"
            :total="pageTotal"
          >
          </el-pagination>
        </div>
      </div>
      <div class="page-from-value">
        <el-table
          ref="table"
          :border="true"
          :max-height="600"
          :data="listData"
          :show-header="true"
          :column-drag-sortable="false"
          class="sky-host-dist"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" :selectable="selectable"> </el-table-column>
          <el-table-column label="终端型号" prop="model" show-overflow-tooltip width="160px" />
          <el-table-column label="使用说明" prop="remarks" show-overflow-tooltip />
          <el-table-column label="终端类型" prop="typeDesc" show-overflow-tooltip width="100px" />
          <el-table-column label="CPU" prop="cpu" show-overflow-tooltip />
          <el-table-column label="内存(GB)" prop="memory" show-overflow-tooltip width="100px" />
          <el-table-column label="磁盘(GB)" prop="diskSize" show-overflow-tooltip width="100px" />
          <el-table-column label="gpu" prop="gpuModel" show-overflow-tooltip />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Pagination, RadioGroup, RadioButton, Input } from 'element-ui'

import { getTerminalList } from '@/api/terminal'

// import lang from '@/lang'
export default {
  name: 'SkySoftwareTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    },
    scenes: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data: function() {
    return {
      selectItem: null,
      dialogVisible: false,
      shwoFunViewDetail: {},
      listData: [],
      selectable: null,
      selectScene: {},
      selectSceneId: null,
      selectFuntion: [],
      pageTotal: 0,
      pageSize: 20,
      searchKeyword: '',
      reqParmas: {
        exactMatchArr: [],
        matchArr: [],
        page: this.page - 1,
        limit: 20,
        sortArr: [{ fieldName: 'memory', direction: 'ASC' }]
      },
      page: 1
    }
  },
  mounted() {
    this.getData()
  },
  created() {
    if (this.scenes.length == 1) {
      this.selectScene = this.scenes[0]
      this.selectSceneId = this.selectScene.sceneId
    }
  },
  methods: {
    refreshTable() {
      this.getData()
    },
    getData() {
      this.reqParmas.page = this.page - 1
      this.reqParmas.limit = this.pageSize
      getTerminalList(this.reqParmas).then(res => {
        this.listData = res.data.content.itemArr
        this.pageTotal = res.data.content.total
      })
    },
    searchReq() {
      if (this.searchKeyword !== '') {
        //
        const exists = this.reqParmas.matchArr.some(obj => obj.fieldNameArr)
        if (exists) {
          for (const iterator of this.reqParmas.matchArr) {
            if (iterator.fieldNameArr) {
              iterator.value = this.searchKeyword
            }
          }
        } else {
          this.reqParmas.matchArr.push({
            type: 'FUZZY',
            fieldNameArr: ['model'],
            value: this.searchKeyword,
            matchRule: 'FULL'
          })
        }
      } else {
        for (let index = 0; index < this.reqParmas.matchArr.length; index++) {
          const element = this.reqParmas.matchArr[index]
          if (element.fieldNameArr) {
            this.reqParmas.matchArr.splice(index, 1)
          }
        }
      }

      this.getData()
    },
    handleSceneSelectionChange(val) {
      this.selectSceneId = val
      // if (this.selectItem) {
      //   this.$emit('addSelect', { select: this.selectItem, sceneId: this.selectSceneId, type: 'Terminal' })
      // }
    },
    handleSelectionChange(val) {
      this.selectItem = val
      // if (this.selectSceneId) {
      //   this.$emit('addSelect', { select: val[0], sceneId: this.selectSceneId, type: 'Terminal' })
      // } else {
      //   this.$store.dispatch('OpenNotification', { message: '请选择你所选的终端的使用场景', type: 'error' })
      // }
    },
    handleCloseDrawer() {
      this.shwoFunViewDetail = {}
      this.dialogVisible = false
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    onSubmit() {
      if (this.selectSceneId) {
        if (this.selectItem.length > 0) {
          this.$emit('addSelect', { select: this.selectItem, sceneId: this.selectSceneId, type: 'Terminal' })
        } else {
          this.$store.dispatch('OpenNotification', { message: '请至少选择一款终端', type: 'error' })
        }
      } else {
        this.$store.dispatch('OpenNotification', { message: '请选择你所选的终端的使用场景', type: 'error' })
      }
      // this.$emit('addSelect', { select: this.selectItem, sceneId: this.selectSceneId, type: 'Terminal' })
    },
    cancel() {
      this.$parent.$parent.closerDrawer()
    },
    //
    handleCurrentChange() {},
    handelPrev() {
      this.page--
      this.getData()
    },
    handelNext() {
      this.page++
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-terminal-view) {
  height: 100%;
  .page-from-item {
    padding: 0 6px;
    line-height: 28px;
    .page-from-item-label {
      font-size: 14px;
      font-weight: 600;
    }
    .page-from-label {
      width: 8%;
    }
    .from-value {
      padding-left: 12px;
    }
    .page-from-item-value {
    }
  }
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
}
</style>
